import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';

import productFiltersSchema, { ProductFiltersSchema } from 'core/schemas/productFilters';
import {
  Form,
  FormSubmitHandler,
  InputField,
  SubmitButton,
} from 'Elements/Form';
import ResetButton from 'Elements/Form/ResetButton';
import SearchPane from 'Elements/SearchPane/SearchPane';

import ManufacturerSelect from '../ProductPage/shared/ManufacturerSelect';
import ProductExportButton from './ProductExportButton';
import ProductImportButton from './ProductImportButton';

const useStyles = makeStyles((theme) => ({
  checkbox: {
    padding: '2px 9px',
  },
  formLabel: {
    margin: '10px 0px 10px 15px',
    fontSize: '12px',
  },
  button: {
    marginLeft: theme.spacing(1),
  },
  pane: {
    height: '100%',
  },
}));

type Props = {
  onSubmit: FormSubmitHandler<ProductFiltersSchema>;
};

export default function FilterProducts({ onSubmit }: Props) {
  const classes = useStyles();

  return (
    <SearchPane>
      <Grid
        className={classes.pane}
        container
        justify="space-between"
        direction="column"
      >
        <Grid item>
          <Typography variant="h6">Suodattimet</Typography>
          <Form
            onSubmit={onSubmit}
            validationSchema={productFiltersSchema}
            initialValues={{}}
          >
            <ManufacturerSelect name="manufacturer_id" variant="outlined" />
            <InputField
              fullWidth
              name="search"
              variant="outlined"
              placeholder="Hae nimellä"
              margin="normal"
              InputLabelProps={{ shrink: true }}
            ></InputField>

            <Grid container justify="flex-end">
              <ResetButton className={classes.button} variant="contained">
                Nollaa
              </ResetButton>
              <SubmitButton
                className={classes.button}
                variant="contained"
                color="secondary"
              >
                Suodata
              </SubmitButton>
            </Grid>
          </Form>
        </Grid>
        <Grid item>
          <Grid container spacing={2} justify="flex-end">
            <Grid item>
              <ProductImportButton />
            </Grid>
            <Grid item>
              <ProductExportButton />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </SearchPane>
  );
}
